/**
 * Adzuki. Modal
 *
 */

(function Modal($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady() {
		// silence the audio when the modal is dismissed
		$('[data-dismiss="modal"]').on('click', function _silenceYouFools() {
			var $modal = $("#modalWindow");

			if (!$(this).hasClass('quick-actions-element')) {
				return;
			}

			$("#modalWindow iframe").attr("src", '');
			$("#modalWindow audio").attr("src", '');
			$("#modalWindow video").attr("src", '');

			// this was added to reset everything that Quick Actions overided
			$modal.find('.modal-header').show();
			$modal.find('.modal-body').removeAttr("style");
			$modal.find('.modal-dialog').removeAttr("style");
			$modal.find('.modal-footer').removeAttr("style");
			$modal.find('.modal-dialog').removeClass('lp-carousel');

			$modal.modal({
				backdrop: true,
				keyboard: true
			});

			$(this).removeClass('quick-actions-element');
		});

		$("#modalWindow").on("hide.bs.modal", function _closedModal() {
			$("#modalWindow").find('.modal-body').removeAttr("style");
			$("#modalWindow").find('.modal-dialog').removeAttr("style");
			$("#modalWindow").find('.modal-footer').removeAttr("style");
			$("#modalWindow").find('.modal-dialog').removeClass('lp-carousel');


			$("#modalWindow iframe").attr("src", '');
			$("#modalWindow audio").attr("src", '');
			$("#modalWindow video").attr("src", '');
		});
	});
}(jQuery, window.Adzuki || {}));
